<mat-card class="overflow-hidden relative h-full">
  <mat-card-header class="[&>*]:w-full">
    <mat-card-title
      ><div class="flex justify-end"
        ><mat-button-toggle-group name="selected-lang" [formControl]="selectedLanguageControl">
          <mat-button-toggle value="hu" [class.!bg-[#ff00004a]]="hasError()?.['hu'] ?? false"
            ><img alt="Magyar zászló" class="w-[20px] mt-[8px]" src="media/flags/hu.svg"
          /></mat-button-toggle>
          <mat-button-toggle value="en" [class.!bg-[#ff00004a]]="hasError()?.['en'] ?? false"
            ><img
              alt="Angol zászló"
              class="w-[20px] mt-[8px]"
              src="media/flags/us.svg" /></mat-button-toggle></mat-button-toggle-group></div></mat-card-title
  ></mat-card-header>
  <mat-card-content [attr.name]="selectedLanguage()"
    ><div class="mt-4"><ng-content /></div
  ></mat-card-content>
  @if (loading()) {
    <pct-common-progress-bar />
  }
</mat-card>
